import { Target } from "../../core/models/Keyword";
import { SearchRepository } from "../../core/repositories/search/SearchRepository";
import Cubit from "../../core/utils/cubit";
import { SearchState } from "./SearchState";

export abstract class ISearchBloc extends Cubit<SearchState> {
    constructor(protected searchRepository: SearchRepository) {
        super({ state: "LOADED", result: [] });
    }
    abstract find(query: string): Promise<Target[]>;
}

export class SearchBloc extends ISearchBloc {
    async find(query: string): Promise<Target[]> {
        try {
            this.emit({ state: "LOADING", result: this.state.result ?? [] });
            const searchResult = await this.searchRepository.find(query);
            this.emit({ state: "LOADED", result: searchResult });
        } catch (error: any) {
            this.emit({ state: "ERROR", error: error.toString() });
        }
        return this.state.result ?? [];
    }

}